<div *ngIf="posts && posts.length" [class.listingPage]="isListingPage" [class.homePage]="isHomePage">
  <p *ngIf="isListingPage" class="blog-title" translate="details.related-remax-articles"></p>
  <div class="blog-title" *ngIf="isHomePage">
      <div>
        <h2 translate="landing-page-residential.cms.useful-info"></h2>
        <h2 translate="landing-page-residential.cms.resources-for-buyers-and-sellers"></h2>
      </div>
      <a href="https://blog.remax.ca" target="_blank">
        <span class="sub-title read-more-link is-flex has-flex-align-center has-flex-content-center">
          {{ 'landing-page-residential.cms.read-more' | translate }} <i class="material-icons">chevron_right</i>
        </span>
      </a>
  </div>
  <div class="blog-posts-container is-flex" >
      <div class="blog-post has-pos-rel" *ngFor="let post of posts">
        <a href="{{ post?.content?.link }}" title="{{ post?.content?.title?.rendered }}" target="_blank">
          <div class="is-flex has-flex-align-center feat-image">
            <img
              appImgIxImage
              appImgLoader
              class="lazypreload lazyload"
              [url]="post?.content?.better_featured_image?.source_url"
              alt="{{ post?.content?.better_featured_image?.alt_text }}"
              [attr.data-src]="post?.content?.better_featured_image?.source_url"
            />
          </div>
        </a>
        <a
          class="read-more text-center"
          href="{{ post.content.link }}"
          target="_blank"
          title="{{ post.content.title.rendered }}"
          [innerHTML]="post.content.title.rendered | safeHtml"
        ></a>
      </div>
  </div>
</div>
